import React from "react";
import apiProxy from "../../api/apiProxy";
import OverrideEdit from "./OverrideEdit";

export default props => {
  return (
    <OverrideEdit
      getOverride={apiProxy.storeLighting.getOverride}
      overrideId={props.match.params.overrideId}
      getScenes={apiProxy.scene.getScenes}
    />
  );
};
